// import { Loading } from 'element-ui';
import { checkUrl } from '@/utils/utils'
import axios from 'axios'
import { Message } from 'element-ui'
import vueRouter from './router'
window.$glob = {
  url: '',
  group: '',
  params: {},
  query: {},
  header: {}
}
var query = window.location.search.substring(1)
if (query != '') {
  query = query.split('&')
  query.forEach(ele => {
    var pair = ele.split('=')
    window.$glob.params[pair[0]] = pair[1]
  })
}
axios.defaults.timeout = 30000
//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
//跨域请求，允许保存cookie
// let loadingInstance = '';
// axios.defaults.withCredentials = true;

// 公共请求前缀，统一设置。其他分层根据情况自己配置
// 所有业务请求路径为 /api/biz/datav 。此处的 /datav 配置在了 public/config.js .url 中。原作者所有业务接口的url都是用了 url 拼接
// 登录等鉴权请求路径为 /api/biz/manage 。 直接体现在接口上即可。 例如 @/api/auth
axios.defaults.baseURL =
    process.env.NODE_ENV === "development" ? "/api_proxy/api" : "/api";

axios.interceptors.request.use(
  config => {
    // loadingInstance = Loading.service({
    //   text: '拼命加载中',
    //   background: 'rgba(0,0,0,0)',
    //   spinner: 'el-icon-loading'
    // });
    let url = config.url
    var glob_params = url.match(/\$\{(.+?)\}/g)
    ;(glob_params || []).forEach(ele => {
      let key = ele.replace('${', '').replace('}', '')
      url = url.replace(ele, window.$glob[key])
    })
    config.url = url
    if (!checkUrl(config.url)) config.url = window.$glob.url + config.url
    let header = window.$glob.header || {}
    config.headers = Object.assign(config.headers, header)
    let data = window.$glob.query || {}
    let key
    if (['get', 'delete'].includes(config.method)) {
      key = 'params'
    } else if (['post', 'put'].includes(config.method)) {
      key = 'data'
    }
    if (typeof config[key] === 'object') {
      config[key] = Object.assign(config[key] || {}, data)
    }
    if (config.headers.proxy) {
      let headers = {}
      for (let ele in config.headers) {
        if (typeof config.headers[ele] !== 'object')
          headers[ele] = config.headers[ele]
      }
      let form = {
        url: config.url,
        method: config.method,
        headers: headers
      }
      form[key] = config[key]
      config.url = window.$website.url + '/visual/proxy'
      config.method = 'post'
      config.data = form
    }
    // 加token
    const accessToken = localStorage.getItem('token')
    if (accessToken) {
      config.headers.Authorization = accessToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
//HTTPrequest拦截
axios.interceptors.response.use(
  config => {
    // loadingInstance.close();
    const status = config.status

    if (status != 200) {
      Message({
        message: config.data.msg || `${config.status} ${config.statusText}`,
        type: 'error'
      })
      return Promise.reject(new Error(config.data.msg))
    } else {
      const { data } = config

      if (!data.success) {
        // 提示错误信息
        Message({
          message:
            config.data.msg ||
            config.data.message ||
            `${config.status} ${config.statusText}`,
          type: 'error'
        })

        // 如果是 401 --> token失效。重新登录
        if (config.data.code === '1000013' && !config.data.success) {
          return vueRouter.replace('/login')
        }
        return Promise.reject(config.data)
      }
    }
    return config
  },
  error => {
    // loadingInstance.close();
    return Promise.reject(new Error(error))
  }
)

export default axios
